import CurrentOpenings from './CurrentOpenings';

export default CurrentOpenings;
